// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .margin-wrapper {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.MED} 0
      ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0;
  }
  .phone-pickup {
    display: none;
  }
  .pickup-heading {
    display: flex;
    align-items: center;
  }
  .add-pickup-link {
    color: ${(props) => props.theme.colorPalette.blue[800]};
  }
`;

export default styles;
